import { fetchAll } from '@/api/dictionary';
import { toTree } from '@/utils/tree.js';
import types from '../types';

const state = {
  dictionaries: []
}

const getters = {
  getEnumsByParentId: (state) => parentId => {
    return (state.dictionaries.find(dictionary => dictionary.id === parentId) || {}).children || [];
  },
  getEnumsByParentValue: (state) => parentValue => {
    return (state.dictionaries.find(dictionary => dictionary.value === parentValue) || {}).children || [];
  },
  getOneEnum: (state, getters) => (parentValue, childValue) => {
    return getters.getEnumsByParentValue(parentValue).find(child => child.value === childValue) || {};
  },
  getOneEnumByName: (state, getters) => (parentValue, childName) => {
    return getters.getEnumsByParentValue(parentValue).find(child => child.name === childName) || {};
  },
  getEnableEnums: (state, getters) => (parentValue) => {
    return getters.getEnumsByParentValue(parentValue).filter(e => e.status === 'enable');
  },
  getEnableEnumsByParentId: (state, getters) => (parentId) => {
    return getters.getEnumsByParentId(parentId).filter(e => e.status === 'enable');
  },
  workflowTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('wf_type');
  },
  levelEnums: (state, getters) => {
    return getters.getEnumsByParentValue('event_level');
  },
  eventFromEnums: (state, getters) => {
    return getters.getEnumsByParentValue('event_from');
  },
  eventStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('event_status');
  },
  eventReasonEnums: (state, getters) => {
    return getters.getEnumsByParentValue('event_reason');
  },
  userTitleEnums: (state, getters) => {
    return getters.getEnumsByParentValue('user_title');
  },
  kbStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('kb_status');
  },
  relTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('wf_rel');
  },
  departTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('depart_type');
  },
  projectStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('pm_status');
  },
  projectStageEnums: (state, getters) => {
    return getters.getEnumsByParentValue('pm_stage');
  },
  attachTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('attach_type')
  },
  projectTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('pm_type');
  },
  projectRoleEnums: (state, getters) => {
    return getters.getEnumsByParentValue('pm_role');
  },
  taskStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('task_status');
  },
  taskTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('task_type');
  },
  assetStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('asset_status');
  },
  contractStateEnums: (state, getters) => {
    return getters.getEnumsByParentValue('contract_state');
  },
  paymentTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('payment_type');
  },
  supplierTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('supplier_type');
  },
  paymentStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('payment_status');
  },
  contractTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('contract_type');
  },
  contractPaymentStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('contract_payment_status');
  },
  callStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('call_status');
  },
  requetStatusEnums: (state, getters) => {
    return getters.getEnumsByParentValue('request_status');
  },
  closeCodeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('close_code');
  }
}

const mutations = {
  [types.SET_DICTIONARIES](state, dictionaries) {
    if (dictionaries) {
      state.dictionaries = dictionaries.length > 0 ? (dictionaries[0].children || []) : [];
    } else {
      state.dictionaries = [];
    }
  }
};

const actions = {
  fetchDictionaries({ commit }) {
    this.tableLoading = true;
    return fetchAll()
      .then(res => {
        const { data: dictionaries } = res.data;
        commit(types.SET_DICTIONARIES, toTree(dictionaries));
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js